import React from 'react'
import { Link, NavLink } from 'react-router-dom';
// Hooks
import useRippleEffect from '../hooks/useRippleEffect';
// CSS
import '../assets/css/footer.css';

export default function Footer() {
  useRippleEffect();
  return (
    <footer>
      <div className="container">
        <div className="sections_container">
          <section className="intro">
            <div className="section_title select_n"><span>C</span>odoHov</div>

            <div className="content">
              <p>CodoHov is an Online Learning platform by Hovered. We are providing quality courses based on Software Development, Programming and Academic Education. All of our courses are directed by professinal mentors across the country. To serve the nation a bunch of manpower is our aim. <br /><Link to="/about" className="select_n">Know More</Link></p>
            </div>
          </section>

          <section className="links">
            <div className="section_title select_n"><span>Q</span>uick Links</div>

            <div className="content select_n">
              <NavLink to="/" exact>Home</NavLink>
              <NavLink to="/courses" exact>Courses</NavLink>
              <NavLink to="/about" exact>About</NavLink>
              <NavLink to="/contact" exact>Contact</NavLink>
              <NavLink to="/privacy" exact>Privacy</NavLink>
              <NavLink to="/terms" exact>Terms</NavLink>
              <NavLink to="/help" exact>Help</NavLink>
            </div>
          </section>

          <section className="contact">
            <div className="section_title select_n"><span>C</span>ontact</div>

            <div className="content">
              <form className="form_primary">
                <div className="inputs">
                  <div className="input_container">
                    <label className="form_label select_n" htmlFor="footer-contact-email">Email</label>
                    <input className="form_input" type="email" id="footer-contact-email" placeholder="Ex: example@example.com" required />
                  </div>
                  <div className="input_container">
                    <label className="form_label select_n" htmlFor="footer-contact-message">Your Message</label>
                    <input className="form_input" type="text" id="footer-contact-message" placeholder="Your Message Goes Here..." required />
                  </div>
                </div>

                <div className="actions">
                  <button className="btn_primary bg-1 ripple-animate ripple-dark">Send</button>
                </div>
              </form>
            </div>
          </section>

          <section className="social_links select_n">
            <div className="section_title"><span>S</span>ocial Links</div>
            
            <div className="content">
              <a href="https://facebook.com/CodoHov" target="_blank"><span className="fab fa-facebook"></span></a>
              <a href="https://instagram.com/CodoHov" target="_blank"><span className="fab fa-instagram"></span></a>
              <a href="https://twitter.com/CodoHov" target="_blank"><span className="fab fa-twitter"></span></a>
              <a href="https://github.com/CodoHov" target="_blank"><span className="fab fa-github"></span></a>
            </div>
          </section>
        </div>


        <div className="copyright select_n">
          <div className="copyright_text"><span className="c-sign">&copy;</span> <span className="brand-name">CodoHov</span> - 2021</div>
          <br />
          <span>All Rights Reserved</span>
        </div>
      </div>
    </footer>
  )
}
